export default {
  id: "lrm",
  name: "Local Relationship Manager",
  shortName: "LRM",
  description: "Partnerships, fundraisers & outreach",
  icon: "handshake",
  color: "#5B9BDA",
  roles: ["super_admin", "admin", "corporate"],
  css: "styles/apps/lrm.css",
  nav: [],
  defaultView: "board",
};
